// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EnrollmentStatus } from './enrollmentStatus.js';
import type { EnrollmentV2ConditionTypeModel } from './enrollmentV2ConditionTypeModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

/**
* @description Eligibility Model
*/
export class EnrollmentV2EligibilityModel {
    'status'?: EnrollmentStatus;
    /**
    * @description Conditions List
    */
    'conditions'?: Array<EnrollmentV2ConditionTypeModel> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof EnrollmentV2EligibilityModel>> = [
        {
            "name":     "status",
            "baseName": "status",
            "type":     "EnrollmentStatus"
        },
        {
            "name":     "conditions",
            "baseName": "conditions",
            "type":     "Array<EnrollmentV2ConditionTypeModel>"
        },
    ];

    static getAttributeTypeMap() {
        return EnrollmentV2EligibilityModel.attributeTypeMap;
    }
}
